module.exports = __webpack_public_path__ + "static/img/wheel-btn.1547e8fa.png";